var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 82,
    viewBox: "0 0 82 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 41C0 63.6 18.4 82 41 82C63.6 82 82 63.6 82 41C82 18.4 63.6 0 41 0C18.4 0 0 18.4 0 41ZM20.1 39C21.9 37.2 24.8 37.2 26.5 39L32.4 44.9C33.2 45.7 34.6 45.7 35.4 44.9L55.5 24.8C57.3 23 60.2 23 61.9 24.8C63.7 26.6 63.7 29.5 61.9 31.2L37.1 56C35.3 57.8 32.4 57.8 30.7 56L20.1 45.4C18.3 43.6 18.3 40.8 20.1 39Z",
    fill: "#43A912"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/CheckMark.47d7a184.svg";
export { ForwardRef as ReactComponent };